import React, {useState, useEffect} from "react";

import {Grid, Typography} from "@mui/material";
import { CompTextFieldNew } from "../../../../../components/newComponents/TextField";
import {connect} from "react-redux";
import {
    setFunction,
    unsetFunction
} from "../../../function.actions";
import { SearchDropdown } from "../../../../../components/newComponents/SearchDropdown";
import {CompPartitionHeader} from "../../../../../components/PartitionHeader";
import {handleCurrentDateCalulcations} from "../../../components/functionFormComponentUtils";
import {hasPermission, PERMISSION_CREATE_FUNCTION_BEHALF_OF_ANOTHER} from "../../../../../permissions";
import {useTranslation} from "react-i18next";
import { ButtonPrimary } from "../../../../../components/newComponents/ButtonPrimary";
import { CompDialog } from "../../../../../components/newComponents/CompDialog";

const FunctionTemplateComponent = (props) => {
    const {
        func,
        editorActivated,
        templates,
        authenticatedUser,
        setFunction,
        organizationTree,
        selectedFunction
    } = props;

    const {t} = useTranslation('translation');
    const [selectedTemplate, setSelectedTemplate] = useState(null);
    const [templateList, setTemplateList] = useState([]);
    const permissionToCreateFunctionBehalfOfAnother = hasPermission(PERMISSION_CREATE_FUNCTION_BEHALF_OF_ANOTHER, authenticatedUser);
    const [dialogOpen, setDialogOpen] = useState(false)

    const handleTemplateChange = (event) => {
        const selectedTemplate = templates.find(
            template => template.id === parseInt(event.target.value)
        );

        if (!selectedTemplate) {
            props.unsetFunction()
            setSelectedTemplate(null)
            return;
        }

        setSelectedTemplate(selectedTemplate);
        const { id, ...data } = selectedTemplate;

        if (
            !permissionToCreateFunctionBehalfOfAnother &&
            !data.organizers.find(o => o.id === authenticatedUser.id)
        ) {
            data.organizers.unshift(authenticatedUser);
        }

        handleCurrentDateCalulcations(data);
        setFunction(data);
    };

    const handleClose = () => {
        setDialogOpen(false);
    };

    const createTemplateLabel = (template) => {
        let name = template.templateName;
        if (template.municipalityTemplate) {
            name += " - " + t('function.public_template');
        }
        else if (template.templateHandlers.length > 1) {
            name += " - " + t('function.group_template');
        }
        else {
            name += " - " + t('function.private_template');
        }
        return name;
    }

    const getFunctionTemplateOptions = () => {
        const response = [];
        for (const i in templates) {
            const template = templates[i];
            response.push({value: template.id, label: createTemplateLabel(template), template: template})
        }
        return response;
    }

    useEffect(() => {
        setTemplateList(getFunctionTemplateOptions());
        setSelectedTemplate(null);
    }, [func.templates])

    const getCreatorName = (creatorId) => {
        let creatorName = "";
        if (selectedFunction.organizers)
        selectedFunction.organizers.forEach(organizer => {
            if (organizer.id === creatorId) {
                creatorName = organizer.firstName + " " + organizer.lastName;
            }
        });
        if (selectedFunction.templateHandlers)
        selectedFunction.templateHandlers.forEach(handler => {
            if (handler.id === creatorId) {
                creatorName = handler.firstName + " " + handler.lastName;
            }
        });

        return creatorName;
    }

    const openDialog = (e) => {
        setDialogOpen(true)
    }

    const handleDialogTemplateChange = (event) => {
        let structure = {
            target: {
                label: event.originalTemplate.templateName,
                template: event.originalTemplate,
                value: event.originalTemplate.id
            }
        }
        handleTemplateChange(structure)
    }
    
    return (
        <>
            <Grid className={'MuiGrid-item'} size={12}>
                <CompPartitionHeader text={t("function.function_template")}/>
                    <Grid sx={{ marginBottom: "20px" }} className={'modalDescription'} tabIndex={0}>
                        <Typography variant="body1" component="p" id="function-template-description">
                            {t("function.function_template_description")}
                        </Typography>
                    </Grid>
                <Grid container sx={{paddingLeft: "0px !important"}} spacing={6} aria-describedby="function-template-description">
                    <Grid size={{xs: 12, sm: 6 }}>
                        <Grid size={{xs: 12, sm: 12 }}>
                            {/* NEW SEARCH DROPDOWN USING MUI V7 AUTOCOMPLETE BELOW */}
                            <SearchDropdown
                                label={t('function.choose_template')}
                                className="function_searchDropdown"
                                selectedValue={selectedTemplate !== null ? selectedTemplate.id : null}
                                rows={templateList}
                                disabled={editorActivated}
                                name="template"
                                onChange={handleTemplateChange}
                            />
                        <Grid size={{xs: 12, sm: 12}} sx={{marginBottom: '2vh'}}>
                            <ButtonPrimary onClick={openDialog} className="search_template_btn">
                                {t('function.search_template')}
                            </ButtonPrimary>
                        </Grid>
                        <CompDialog
                            organizationTree={organizationTree}
                            open={dialogOpen}
                            onClose={handleClose}
                            onTemplateSelected={handleDialogTemplateChange}
                            selectedFunction={selectedFunction}
                        />
                        </Grid>
                        <Grid sx={{width: "100% !important", display:"flex", gap: "30px"}}size={{xs: 12, sm: 6 }}>
                            <CompTextFieldNew
                                label={`${t('function.template_creator_name')}`}
                                isLabelShrink={true}
                                value={(getCreatorName(selectedFunction.creatorId) ?? '').trim() !== ''
                                      ? getCreatorName(selectedFunction.creatorId)
                                      : t('function.not_known')
                                  }
                                disabled={true}
                                name="templateCreator"
                            />
                            {/* CREATION DATE COMMENTED OUT DUE TO CUSTOMER REQUEST. ADD BACK IF/WHEN FUNCTIONALITY IS IMPLEMENTED TO BACKEND */}
                        </Grid>
                    </Grid>
                    <Grid size={{xs: 12, sm: 6 }}>
                        <CompTextFieldNew
                            label={t('function.template_usage_information')}
                            value={selectedTemplate !== null ? selectedTemplate.templateDescription : null}
                            disabled={true}
                            isLabelShrink={true}
                            name="templateDescription"
                            multiline
                            rows={6}
                        />
                    </Grid>
                </Grid>
            </Grid>
        </>
    );
}

const mapStateToProps = (state) => {
    // return state;
    return {
        func: state.func,
        templates: state.func.templates,
        authenticatedUser: state.auth.authenticatedUser,
        selectedFunction: state.func.selectedFunction,
        organizationTree: state.municipality.organizationTree,
    }
}
const mapDispatchToProps = dispatch => {
    return {
        setFunction: (data) => dispatch(setFunction(data)),
        unsetFunction: () => dispatch(unsetFunction())
    };
}

export const FunctionTemplateComp = connect(mapStateToProps, mapDispatchToProps)(FunctionTemplateComponent);
